module.exports = __webpack_public_path__ + "static/media/Risk Management Report_221123.298bbcc8.pdf";